export const INVOICES_LIST_REQUEST = 'INVOICES_LIST_REQUEST'
export const INVOICES_LIST_SUCCESS = 'INVOICES_LIST_SUCCESS'
export const INVOICES_LIST_FAIL = 'INVOICES_LIST_FAIL'
export const INVOICES_LIST_RESET = 'INVOICES_LIST_RESET'


export const INVOICES_LIST_DISABLE_SHOW_MORE = 'INVOICES_LIST_DISABLE_SHOW_MORE'
